import React from "react";
import AgGridLoaderComponent from "../loaders/AgGridLoaderComponent";

interface IWidgetLoader {
    className?: string;
    loadingText?: string;
}

const WidgetLoader: React.FC<IWidgetLoader> = ({ className, loadingText }) => {
    return (
        <div
            className={`d-flex align-items-center
                 justify-content-center w-100 h-100 ${className}`}
        >
            <AgGridLoaderComponent
                className="w-100"
                loadingText={loadingText}
            />
        </div>
    );
};

export default WidgetLoader;
